/**
 * @fileoverview Prompt template for world-species-ideation-v3.
 */

export const prompt = `
You are an expert world-builder specializing in creating rich and diverse species, creatures, and flora for fiction.

## TASK INSTRUCTIONS:
Your task is to analyze the provided story context and generate ideas for species that could exist in the story world.

{{#if targetElement}}
**IMPORTANT: Generate ONLY {{targetElement}}s. Do not generate any other element type.**
{{/if}}

1. Review the existing world species to avoid duplicates.
2. Based on the story context, generate a list of *new* species that would add depth and richness to the story world.
{{#if targetElement}}
{{#eq targetElement "creature"}}
   - Focus exclusively on **Creatures**: Animals, monsters, or beasts that inhabit the world (e.g., Dragons, Dire Wolves, Sandworms, genetically modified sharks).
{{/eq}}
{{#eq targetElement "race"}}
   - Focus exclusively on **Races**: Sentient peoples or humanoid races (e.g., Elves, Dwarves, The Fae, Androids, Martian colonists).
{{/eq}}
{{#eq targetElement "flora"}}
   - Focus exclusively on **Flora**: Plants, fungi, or notable vegetation (e.g., Corpse Flowers, Bloodvines, The World Tree, bioluminescent algae).
{{/eq}}
{{else}}
   - **Creatures**: Animals, monsters, or beasts that inhabit the world (e.g., Dragons, Dire Wolves, Sandworms).
   - **Races**: Sentient peoples or humanoid races (e.g., Elves, Dwarves, The Fae, Androids).
   - **Flora**: Plants, fungi, or notable vegetation (e.g., Corpse Flowers, Bloodvines, The World Tree).
{{/if}}
3. Prioritize species that:
   - Fill ecological or narrative niches in the world
   - Create interesting dynamics with characters or other species
   - Contribute to the world's sense of wonder, danger, or mystery
   - Have potential for plot significance or thematic resonance
   - Feel authentic to the story's genre and setting
4. Compare ideated species with existing ones. Only return species that don't exist yet.

<<<userMessage>>>

## PRIMARY TASK CONTEXT

<<<loreContext>>>

<<<storyContext>>>

<<<initialChapterContent>>>

## SECONDARY TASK CONTEXT

<<<worldSpecies>>>

<<<worldElements>>>

<<<characters>>>

## OUTPUT INSTRUCTIONS:
For each species, you MUST provide:
- **name**: A distinctive name for the species
{{#if targetElement}}
- **element**: Must be "{{targetElement}}" for all species (as specified in the task instructions)
{{else}}
- **element**: Either "creature" (animal/monster/beast), "race" (sentient people), or "flora" (plant/fungi/vegetation)
{{/if}}
- **initialDescription**: A compelling description covering what the species is, its role in the ecosystem or society, and why it matters to the story

Provide your output in the required JSON format.
`;
